<ng-container>
  <div class="loader absolute" *ngIf="isLoading">
    <svg class="circular" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
    </svg>
  </div>
  <div class="table-area" *ngIf="!isLoading">
    <div class="content-body table-container">
      <table class="table-header" sortable-table="sortable-table" (sorted)="sortTableByColumn($event)">
        <colgroup>
          <col *ngFor="let col of dealerTableHeader" [width]="col.width"/>
        </colgroup>
        <thead>
          <tr>
            <th *ngFor="let header of dealerTableHeader" [sortable-column]="header.value" [ngClass]="header?.tooltip ? 'flex v-center' : ''">
               {{header.name}}
              <div class="--g-tooltip-content" *ngIf="header?.tooltip" (mouseenter)="commonService.setTooltipPosition($event, 'top-center')">
                <comp-icon class="--g-tooltip-icon" [icon]="'info'" [size]="16" [color]="'#4f566b'"></comp-icon>
                <div class="--g-tooltip" style="text-transform: none" *ngIf="header.tooltip === 'skipped'">This feature applies only when the motion score feature is enabled. <br/>Additionally, this value is not included in AI request counts. Skipped events will be delivered to the Central station just like traditional video events.</div>
                <div class="--g-tooltip" style="text-transform: none" *ngIf="header.tooltip === 'billable'">Number of AI events counted toward billing. This matches the Video AI Charges quantity on the invoice, while AI EVENTS is the total number of AI events regardless of billing.</div>
              </div>
            </th>
          </tr>
        </thead>
      </table>
      <div class="table-body">
        <table>
          <colgroup>
            <col *ngFor="let col of dealerTableHeader" [width]="col.width"/>
          </colgroup>
          <tbody>
            <tr *ngIf="pagedItems?.length === 0 && !isLoading" style="text-align: center; color: #999;">
              <td [attr.colspan]="dealerTableHeader.length">{{ this.searchText?.length != 0 && this.searchText?.length < 3 ? 'Please enter at least 3 characters' : 'No Dealer'}}</td>
            </tr>
            <ng-container *ngIf="!isLoading">
              <tr *ngFor="let dealer of pagedItems" (click)="moveToDetail(dealer)">
                <td>{{dealer.dealer_name}}</td>
                <td>{{parseServicePlanTypeToPlanName(dealer.current_month_service_plan_type)}}</td>
                <td>{{formatNumbersWithComma(dealer.site_count)}}</td>
                <td> 
                  <div [ngClass]="dealer.is_videoai_enabled ? 'cloudai-enabled' : 'cloudai-disabled'">{{dealer.is_videoai_enabled ? 'Enabled' : 'Disabled'}}</div>
                </td>
                <td>{{dealer.video_events ?? 0}}</td>
                <td>{{dealer.ai_true_alarm ?? 0}}</td>
                <td>{{dealer.ai_false_alarm ?? 0}}</td>
                <td>{{dealer.ai_request ?? 0}}</td>
                <td *ngIf="isBillableMonth">{{dealer.ai_billable ?? 0}}</td>
                <td>
                  <div class="more-content v-center" #dealerActionMenus *ngIf="tab === 'dealers'" [id]="dealer.dealer_id" (mouseover)="setMorePosition(dealer.dealer_id)">
                    <div class="more-selector" (click)="$event.stopPropagation();toggleMenu(dealer)">
                      <comp-icon [icon]="'more_horiz'" [size]="20" [color]="'hsla(0, 0%, 0%, 0.87)'"></comp-icon>
                    </div>
                    <div class="more" [class.show]="dealer.isShowMenu" [id]="'more-'+dealer.dealer_id">
                      <div class="more-item pointer row" *ngIf="meDealerInfo.dealer_id != dealer.dealer_id" (click)="$event.stopPropagation();goToDealer(dealer.dealer_id)">
                        <div>Go to Dealer</div>
                      </div>
                      <div class="more-item pointer row" (click)="$event.stopPropagation();moveToDetail(dealer)">
                        <div>Go to Detail</div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
      <!-- SLOT : pagination-->
      <ng-content></ng-content>
    </div>
  </div>
</ng-container>